var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardsCustomFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.851,
    height: 11.851,
    viewBox: "0 0 11.851 11.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-circle",
    d: "M469.675,1097.641a4.966,4.966,0,1,1,4.966-4.966,4.966,4.966,0,0,1-4.966,4.966Zm0-10.641a5.675,5.675,0,1,0,5.675,5.675,5.674,5.674,0,0,0-5.675-5.675Zm2.128,5.321H470.03v-1.773a.355.355,0,1,0-.709,0v1.773h-1.774a.355.355,0,0,0,0,.709h1.774v1.773a.355.355,0,1,0,.709,0v-1.773H471.8a.355.355,0,0,0,0-.709Z",
    transform: "translate(-464 -1087)",
    fill: "#798697",
    stroke: "#798798",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsCustomFilterIcon);
export default __webpack_public_path__ + "static/media/cards-custom-filter-icon.4c48185c4fe88853953bd4813084dab0.svg";
export { ForwardRef as ReactComponent };